import * as Sentry from '@sentry/browser';
import { log } from '../log';
function captureErrorToSentry(config) {
    if (process.env.REACT_APP_NODE_ENV === 'development') {
        console.error(config);
        return;
    }
    Sentry.withScope(function (scope) {
        scope.setTag('lexie-error', 'true');
        scope.setTag(config.tag.name, config.tag.value);
        scope.setLevel(config.level);
        scope.setExtra('message', config.message);
        if (config.metadata) {
            scope.setExtra('metadata', config.metadata);
        }
        if (!(config.error instanceof Error)) {
            scope.setExtra('details', config.error);
            Sentry.captureException(new Error(config.message));
            return;
        }
        Sentry.captureException(config.error);
    });
}
export function logError(config) {
    if (process.env['REACT_APP_NODE_ENV'] === 'development') {
        log('sentry:', config.message, config);
        return;
    }
    captureErrorToSentry(config);
}
